///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { DuplicateTypeEnum } from '../duplicate-type-enum';

@Pipe({
    name: 'duplicateTypePipe',
    standalone: false
})
export class GtthDuplicateTypePipe implements PipeTransform {
    transform(value: number): string {
        let type: string;
        switch (value) {
            case DuplicateTypeEnum.NEW:
                type = 'Import as new';
                break;
            case DuplicateTypeEnum.NOT_IMPORT:
                type = "Don't import";
                break;
            case DuplicateTypeEnum.POTENTIAL_DUPLICATE:
                type = 'Merge LOSes';
                break;
            case DuplicateTypeEnum.UPDATE_ORIGIN:
            default:
                type = 'Update existing';
        }
        return type;
    }
}
